import { ReduxStore } from 'store/types';

export const selectCastPinNeeded = (store: ReduxStore) => store.cast.pinNeeded;
export const selectItemToCast = (store: ReduxStore) => store.cast.itemToCast;
